/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import { connect } from 'react-redux';
import StudiesComponent from './studies.component';
import * as actions from '../../actions/actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    rows: state.study.rows,
    isFetching: state.study.isFetching,
    error: state.study.error,
    userId: state.login.user.userId,
    selectedSponsor: state.sponsor.selectedSponsor,
    reports: state.qlikReports.reports,
    isFetchingReports: state.qlikReports.isFetching,
    reportsError: state.qlikReports.error,
    reportsEnabled: state.qlikReports.reportsEnabled
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadData: (userId, sponsor) => {
      dispatch(actions.fetchActiveStudies(userId, sponsor));
    },
    loadReports: (userId, sponsor) => {
      dispatch(actions.setQlikSession(userId, sponsor));
    },
    getReportsStatus: (sponsor) => {
      dispatch(actions.fetchReportsStatus(sponsor));
    }
  };
};

const StudiesContainer = connect(mapStateToProps, mapDispatchToProps)(StudiesComponent);

export default StudiesContainer;
